const Preview = function({category, subcategory}){
    return <div className="w-100 h-100">
        <iframe title="Preview" src={`https://karma-trust.appypie.workers.dev/divkit/desktop/${category}`} className="w-100 h-100" frameBorder={0}></iframe>
    </div>
}

export default Preview